import NProgress from 'nprogress';
import { useEffect, useMemo } from 'react';
// material
import { useTheme } from '@mui/material/styles';
import { Box, GlobalStyles, CircularProgress, Typography } from '@mui/material';
import { DialogAnimate } from './animate';
import { useStores } from 'src/models';
import { pxToRem } from 'src/theme/typography';

// ----------------------------------------------------------------------

export function ProgressBarStyle() {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        '#nprogress': {
          pointerEvents: 'none',
          '& .bar': {
            top: 0,
            left: 0,
            height: 2,
            width: '100%',
            position: 'fixed',
            zIndex: theme.zIndex.snackbar,
            backgroundColor: theme.palette.primary.main,
            boxShadow: `0 0 2px ${theme.palette.primary.main}`,
          },
          '& .peg': {
            right: 0,
            opacity: 1,
            width: 100,
            height: '100%',
            display: 'block',
            position: 'absolute',
            transform: 'rotate(3deg) translate(0px, -4px)',
            boxShadow: `0 0 10px ${theme.palette.primary.main}, 0 0 5px ${theme.palette.primary.main}`,
          },
        },
      }}
    />
  );
}

function ProgressBar() {
  NProgress.configure({
    showSpinner: false,
  });

  useMemo(() => {
    NProgress.start();
  }, []);

  useEffect(() => {
    NProgress.done();
  }, []);

  return null;
}

export default function LoadingScreen({ ...other }) {
  const { loadingStore } = useStores();

  const theme = useTheme();

  useEffect(() => {
    if (!loadingStore.loading) {
      loadingStore.setMessage('');
    }
  }, [loadingStore, loadingStore.loading]);

  return (
    <DialogAnimate
      id="loading"
      open={loadingStore.loading}
      PaperProps={{
        style: {
          boxShadow: 'none',
          backgroundColor: 'transparent',
          overflow: 'hidden',
          textAlign: 'center',
          maxWidth: '100%',
        },
      }}
      slots={{
        backdrop: () => (
          <Box
            sx={{
              position: 'fixed',
              left: 0,
              top: 0,
              right: 0,
              bottom: 0,
              backgroundColor: '#000',
              opacity: 0,
            }}
          ></Box>
        ),
      }}
      sx={{ maxWidth: '100%' }}
    >
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ProgressBar />
        <CircularProgress sx={{ width: 70, height: 70, color: theme.palette.custom.blue }} />
      </Box>
      {loadingStore.message && (
        <Typography variant='Kor_16_b' sx={{ mt: pxToRem(30), color: theme.palette.custom.blue }}>
          {loadingStore.message}
        </Typography>
      )}
    </DialogAnimate>
  );
}
